import { Option } from '@repo/ui';
import { useState } from 'react';

/**
 * Hook responsável por gerenciar o estado de toque (touched) dos filtros de Organização e Curso - Obrigatoriedade de preenchimento dos campos.
 *
 * @returns {Object} - Objeto com o estado de toque e a função de validação.
 * @property {Object} touched - Estado de toque dos filtros.
 * @property {Function} validate - Função de validação dos filtros.
 *
 * @example
 * ```tsx
 * const { touched, validate } = useEntityAndCourseFiltersTouched();
 * ```
 */

export const useEntityAndCourseFiltersTouched = () => {
  const [touched, setTouched] = useState({ org: false, course: false });

  const validate = (org: Option | null, course: Option | null) => {
    setTouched({ org: true, course: true });
    return !!org && !!course;
  };

  return { touched, validate };
};
